import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './LoadingAnimation.css';

// 1. USE YOUR LOGO URL
const LOGO_URL = "https://website-wellshape.vercel.app/static/media/logo.6605686758b7ff0f6430.jpeg";

const LoadingAnimation = () => {
  const showLoading = useSelector((state) => state.appstate.showLoading); 
  const [animationStage, setAnimationStage] = useState(0); // 0: initial, 1: WellShape, 2: Logo, 3: Happy Shopping

  // Reset animation stage when showLoading changes
  useEffect(() => {
    if (showLoading) {
      // Delay the start slightly to ensure CSS classes are ready
      const timer = setTimeout(() => setAnimationStage(1), 50); 
      return () => clearTimeout(timer);
    } else {
      setAnimationStage(0); 
    }
  }, [showLoading]);

  // Handle animation completion for WellShape to move to Logo
  const handleWellShapeAnimationEnd = (event) => {
    // Only trigger if it's the last letter's reveal animation ending
    if (event.animationName === 'revealLetter' && event.target.id === 'letter-e-end') {
      setAnimationStage(2); // Show Logo
    }
  };

  // Handle animation completion for Logo to move to Happy Shopping
  const handleLogoAnimationEnd = (event) => {
    // The logo will use the 'fadeIn' animation
    if (event.animationName === 'fadeIn') { 
      setAnimationStage(3); // Show Happy Shopping
    }
  };

  if (!showLoading) {
    return null; 
  }

  const wellShapeText = "WELLSHAPE";

  return (
    <div className={`loading-overlay ${showLoading ? 'visible' : ''}`}>
      <div className="animation-container">

        {/* 2. LOGO INTEGRATION */}
        <div 
          className={`loading-logo ${animationStage >= 2 ? 'show-logo' : ''}`}
          onAnimationEnd={animationStage === 2 ? handleLogoAnimationEnd : null}
        >
          <img 
            src={LOGO_URL} 
            alt="WellShape Logo" 
            className="logo-image" 
          />
        </div>

        {/* "WellShape" Text Animation - NO CHANGES NEEDED HERE FOR PERMANENCE */}
        <div className="wellshape-text">
          {wellShapeText.split('').map((char, index) => (
            <span
              key={index}
              id={index === wellShapeText.length - 1 ? 'letter-e-end' : null} 
              className={`wellshape-letter ${animationStage === 1 || animationStage >= 2 ? 'animate' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
              onAnimationEnd={index === wellShapeText.length - 1 && animationStage === 1 ? handleWellShapeAnimationEnd : null}
            >
              {char}
            </span>
          ))}
        </div>

        {/* "Happy Shopping" Text - Ensure visibility after stage 3 */}
        <p className={`happy-shopping-text ${animationStage === 3 ? 'show-happy-shopping' : ''}`}>Happy Shopping</p>
      </div>
    </div>
  );
};

export default LoadingAnimation;